/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchEquipmentEventHistoryResponse } from './search-equipment-event-history-response';


export interface SearchEquipmentEventHistoryResponsePagedList { 
    totalCount?: number;
    items?: Array<SearchEquipmentEventHistoryResponse> | null;
}

